import { UserReset } from 'client/voladeum/auth/types';

export const user_reset_default: UserReset = { login: '' };
